import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewFollowerEngagementIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon
    data-testid="new-follower-engagement-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.70968 4.50432C4.70968 2.56894 6.18281 1 8 1C9.81719 1 11.2903 2.56894 11.2903 4.50432C11.2903 6.4397 9.81719 8.00863 8 8.00863C6.18281 8.00863 4.70968 6.4397 4.70968 4.50432ZM8 2.23682C6.82417 2.23682 5.87097 3.25201 5.87097 4.50432C5.87097 5.75662 6.82417 6.77182 8 6.77182C9.17583 6.77182 10.129 5.75662 10.129 4.50432C10.129 3.25201 9.17583 2.23682 8 2.23682Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.90323 10.4823C3.94118 10.4823 3.16129 11.3129 3.16129 12.3375V13.3173C3.16129 13.3322 3.17144 13.3449 3.18527 13.3473C6.37398 13.9018 9.62602 13.9018 12.8147 13.3473C12.8286 13.3449 12.8387 13.3322 12.8387 13.3173V12.3375C12.8387 11.3129 12.0588 10.4823 11.0968 10.4823H10.8329C10.8125 10.4823 10.7922 10.4857 10.7728 10.4925L10.1027 10.7255C8.7364 11.2006 7.26359 11.2006 5.89728 10.7255L5.2272 10.4925C5.20781 10.4857 5.18753 10.4823 5.16712 10.4823H4.90323ZM2 12.3375C2 10.6298 3.29982 9.24545 4.90323 9.24545H5.16712C5.30996 9.24545 5.45189 9.26951 5.58767 9.31673L6.25774 9.54976C7.38984 9.94346 8.61016 9.94346 9.74225 9.54976L10.4123 9.31673C10.5481 9.26951 10.69 9.24545 10.8329 9.24545H11.0968C12.7002 9.24545 14 10.6298 14 12.3375V13.3173C14 13.9384 13.5774 14.4679 13.0019 14.568C9.68921 15.144 6.31079 15.144 2.99815 14.568C2.42262 14.4679 2 13.9384 2 13.3173V12.3375Z"
      fill="currentColor"
    />
  </Icon>
);
